import { lazy } from 'react';
import { ModuleConstants } from '../../common/constant/modules';
import { ModuleRoutesComponentInterface } from '../../common/routes/types';
import { generateImage } from '../../common/utils/generateImage';
import {
  ComponentsMapInterface,
  RouteConstantsInterface,
  ScreenNamesInterface,
} from './types';

export enum EmailRedirectedRoutes {
  SIGNUP = 'signup',
  VERIFY = 'verify-user',
  RESET_PASSWORD = 'reset-password',
}

export enum ScreenNameEnums {
  USER_MANAGEMENT,
  ROLES,
  USERS,
  USER_DETAILS,
  CONFIG,
  SITE_LEVEL_CONFIG,
  ROLE_LEVEL_CONFIG,
}

export enum RouteConstantEnums {
  USER_MANAGEMENT,
  ROLES,
  USERS,
  USER_DETAILS,
  CONFIG,
  SITE_LEVEL_CONFIG,
  ROLE_LEVEL_CONFIG,
}

export enum ComponentEnum {
  ROLES,
  USERS,
  SITE_LEVEL_CONFIG,
  ROLE_LEVEL_CONFIG,
}

export const ScreenNames: ScreenNamesInterface = {
  USER_MANAGEMENT: 'User Management',
  ROLES: 'Roles',
  USERS: 'Users',
  USER_DETAILS: 'Users',
  CONFIG: 'Configs',
  SITE_LEVEL_CONFIG: 'Site Level',
  ROLE_LEVEL_CONFIG: 'Role Level',
};

export const RouteConstants: RouteConstantsInterface = {
  USER_MANAGEMENT: '/user-management',
  ROLES: '/user-management/roles',
  USERS: '/user-management/users',
  USER_DETAILS: '/user-management/users/:path',

  CONFIG: '/config',
  SITE_LEVEL_CONFIG: '/config/site',
  ROLE_LEVEL_CONFIG: '/config/role',
};

export enum ComponentsMapEnums {
  ROLES,
  USERS,
  SITE_LEVEL_CONFIG,
  ROLE_LEVEL_CONFIG,
}

export const ComponentsMap: ComponentsMapInterface = {
  ROLES: lazy(() => import('../pages/roles-dashboard')),
  USERS: lazy(() => import('../pages/users-dashboard')),
  SITE_LEVEL_CONFIG: lazy(() => import('../pages/site-level-config')),
  ROLE_LEVEL_CONFIG: lazy(() => import('../pages/role-level-config')),
};

const getAumModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.USER_MANAGEMENT,
      route: RouteConstants.USER_MANAGEMENT,
      title: ScreenNames.USER_MANAGEMENT,
      icon: generateImage({
        noScale: true,
        name: 'home-05',
        alt: 'User Management Home',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.ROLES,
          route: RouteConstants.ROLES,
          title: ScreenNames.ROLES,
          component: ComponentsMap.ROLES,
        },
        // {
        //   id: ModuleConstants.PUBLIC_MODULE_ID,
        //   sidebarVisibility: false,
        //   route: RouteConstants.USER_DETAILS,
        //   title: ScreenNames.USER_DETAILS,
        //   component: ComponentsMap.USER_DETAILS,
        // },
        {
          id: ModuleConstants.USERS,
          route: RouteConstants.USERS,
          title: ScreenNames.USERS,
          component: ComponentsMap.USERS,
        },
      ],
    },
    {
      id: ModuleConstants.CONFIG,
      route: RouteConstants.CONFIG,
      title: ScreenNames.CONFIG,
      icon: generateImage({
        noScale: true,
        name: 'settings-04',
        alt: 'config',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.SITE_LEVEL_CONFIG,
          route: RouteConstants.SITE_LEVEL_CONFIG,
          title: ScreenNames.SITE_LEVEL_CONFIG,
          component: ComponentsMap.SITE_LEVEL_CONFIG,
        },
        {
          id: ModuleConstants.ROLE_LEVEL_CONFIG,
          route: RouteConstants.ROLE_LEVEL_CONFIG,
          title: ScreenNames.ROLE_LEVEL_CONFIG,
          component: ComponentsMap.ROLE_LEVEL_CONFIG,
        },
      ],
    },
  ];
};

export default getAumModuleRoutes;
